'use strict';

/* eslint-disable */
export default (bgColor: string, height: string, width: string, x: number = 0, y: Number = 0) => {
  return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" ` +
         `style="fill:${encodeURIComponent(bgColor)}">` +
         `<rect x="${x}" y="${y}" width="${width}" height="${height}" /></svg>')`;
}
/* eslint-enable */
